declare namespace $ {

	export class $mol_icon_form_dropdown extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=dropdown.view.tree.d.ts.map